import { Controller } from "stimulus";

export default class extends Controller {
  handleClick(event) {
    let buttontype = event.currentTarget.dataset.buttontype;
    const field = document.getElementById("purchase_invoice_button_type");
    field.value = buttontype;

    const text_area = document.getElementById("purchase_invoice_comment");
    text_area.value = "";
  }
}
